import wretch from 'wretch';
import * as v from 'valibot';
import {
  BundleSchema,
  SessionSchema,
} from '@fe-learner-common/api/schemas/sessionsSchema';
import { localizedErrorHandlers } from '@fe-core/api';

const delayPromise = new Promise((resolve) => setTimeout(resolve, 800));

const GetSessionsResponseSchema = v.object({
  sessions: v.array(SessionSchema),
  bundles: v.array(BundleSchema),
});

export type TSessionsResponse = v.Output<typeof GetSessionsResponseSchema>;

export const getSessions = async ({
  baseUrl,
}: {
  baseUrl: string;
}): Promise<TSessionsResponse> => {
  const url = `${baseUrl}/cat/sessions`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  const dataPromise = localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(GetSessionsResponseSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-common | getSessions | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getSessions response');
    }
  });

  const [result, _] = await Promise.all([dataPromise, delayPromise]);
  return result;
};
